import { render, staticRenderFns } from "./EmptyImageIcon.vue?vue&type=template&id=c7712238"
import script from "./EmptyImageIcon.vue?vue&type=script&lang=js"
export * from "./EmptyImageIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports